import axiosInstance from 'src/config/axiosInstance';

export const getAirpotsList = async (input) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_HOST_API}/flights/location/${input}`
  );
  return response.data;
};
